module.exports = __webpack_public_path__ + "img/_itau.png";